import { render, staticRenderFns } from "./ntfDetail.vue?vue&type=template&id=496a5e4b&scoped=true"
import script from "./ntfDetail.vue?vue&type=script&lang=js"
export * from "./ntfDetail.vue?vue&type=script&lang=js"
import style0 from "./ntfDetail.vue?vue&type=style&index=0&id=496a5e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a5e4b",
  null
  
)

export default component.exports